module.exports = __webpack_public_path__ + "statics/img/6.64d804e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/6.jpg
// module id = 2Abr
// module chunks = 1